import { alpha, Typography } from "@mui/material";

import { api } from "../../../../../api/api";
import { CONSTS } from "../../../../../config/objectConst";
import { notifyError } from "../../../../../shared/errors";
import { saveData } from "../../../../../tools/functions";

const ExportCsvExample = () => {
  const exportCsvExample = async () => {
    try {
      const response = await api.exportCsvExampleApi();
      if (response && response.status === 200) {
        const data = response.data,
          fileName = `${CONSTS.PROJECT_NAME}_Template.csv`;
        saveData(data, fileName);
      }
    } catch (error) {
      notifyError(error);
    }
  };

  return (
    <Typography
      className="text-accent-upload"
      sx={{
        color: "#2c82e4",
        textDecoration: "underline",
        cursor: "pointer",
        fontSize: "14px",
        lineHeight: "18px",
        transition: "color 0.3s",
        "&:hover": {
          color: alpha("#2c82e4", 0.8),
        },
      }}
      onClick={exportCsvExample}
    >
      Download CSV example
    </Typography>
  );
};

export default ExportCsvExample;
